import tokens from "@safetyculture/design-tokens";
export const shadows = tokens.shadow;
